import CoreUtils from '../../common/utils/CoreUtils';
import NumberUtils from '../../common/utils/NumberUtils';

import EnergyValue from '../../common/value-types/EnergyValue';
import { EnergyValueViewMode } from '../../common/value-types/EnergyValueViewMode';
import MetadataHelper from '../../common/value-types/MetadataHelper';

import './EnergyCellViewTemplate.css';

const canvasHeight = 50;
const canvasWidth = 70;
const graphHorzMargin = 8;
const graphVertMargin = 6;

const canvasContext = '2d';

const barOutlineColor = '#0000FF1E';
const positiveBarFillColor = '#FF00FF1E';
const negativeBarFillColor = '#00FFFF46';

const divElement = 'div';
const canvasElement = 'canvas';

const pwxEnergyContainer = 'pwx-energy-container';
const pwxEnergyTextContainer = 'pwx-energy-text-container';
const pwxEnergyText = 'pwx-energy-text';
const pwxEnergyGraphContainer = 'pwx-energy-graph-container';
const pwxEnergyGraph = 'pwx-energy-graph';

export default function EnergyCellViewTemplate(container, options) {
  var energyValue = options.value;

  if (options.data.energyValueViewMode === EnergyValueViewMode.referenceValue) {
    var metadataField = MetadataHelper.resolveMetadataField(options.column.dataField);
    if (CoreUtils.isDefinedAndNotNull(options.data[metadataField]))
      energyValue = options.data[metadataField].referenceValue;
  }

  if (CoreUtils.isUndefinedOrNull(energyValue) || !(energyValue instanceof EnergyValue))
    return;
   
  var displayText = (energyValue.value !== 0) || (energyValue.value === 0 && options.data.showZeroValues)
    ? NumberUtils.formatNumber(
      energyValue.value,
      options.data.locale
    )
    : null;

  if (!container.classList.contains(pwxEnergyContainer))
    container.classList.add(pwxEnergyContainer);

  var textContainerDiv = document.createElement(divElement);
  textContainerDiv.className = pwxEnergyTextContainer;
  container.append(textContainerDiv);

  var textDiv = document.createElement(divElement);
  textDiv.className = pwxEnergyText;
  textDiv.innerText = displayText;
  textContainerDiv.append(textDiv);

  if (energyValue.resolution < 2)
    return;

  var graphContainerDiv = document.createElement(divElement);
  graphContainerDiv.className = pwxEnergyGraphContainer;
  container.append(graphContainerDiv);

  var graphCanvas = document.createElement(canvasElement);
  graphCanvas.className = pwxEnergyGraph;
  graphCanvas.id = `${options.data.scheduleId}-${options.column.dataField}-canvas`;
  graphCanvas.height = canvasHeight;
  graphCanvas.width = canvasWidth;
  graphContainerDiv.append(graphCanvas);

  renderEnergyGraph(graphCanvas.id, energyValue.values);
}

function renderEnergyGraph(elementId, values) {
  if (CoreUtils.isUndefinedOrNull(elementId))
    return;

  if (CoreUtils.isUndefinedOrNull(values) || !Array.isArray(values))
    return;

  const canvas = document.getElementById(elementId);
  if (CoreUtils.isUndefinedOrNull(canvas))
    return;

  var graphWidth = canvasWidth - (graphHorzMargin * 2);
  var graphHeight = canvasHeight - (graphVertMargin * 2);

  if (graphWidth <= 0 || graphHeight <= 0)
    return;

  values = values.map(
    value => CoreUtils.isDefinedAndNotNull(value)
      ? value
      : 0
  );

  var maxValue = Math.max(0, ...values);
  var minValue = Math.min(0, ...values);
  var totalRange = maxValue - minValue;

  var baseline = minValue === 0
    ? canvasHeight - graphVertMargin
    : maxValue === 0
      ? graphVertMargin
      : graphVertMargin + (maxValue / totalRange) * graphHeight;

  var barWidth = graphWidth / values.length;
  var barHeights = values.map(value => {
    return totalRange > 0 && value !== 0
      ? Math.abs(value) / totalRange * graphHeight
      : 1;
  });

  var context = canvas.getContext(canvasContext);
  if (CoreUtils.isUndefinedOrNull(context))
    return;

  context.strokeStyle = barOutlineColor;

  for (var index = 0; index < values.length; index++) {
    var value = values[index];
    var barHeight = barHeights[index];

    var x = graphHorzMargin + (index * barWidth);
    var y = value >= 0
      ? baseline - barHeight
      : baseline;

    context.fillStyle = value >= 0
      ? positiveBarFillColor
      : negativeBarFillColor;

    context.fillRect(x, y, barWidth, barHeight);
    context.strokeRect(x, y, barWidth, barHeight);
  }
}